import { withRouter } from "react-router-dom";
import * as _ from "lodash";
import MainContent from "../../boxes/MainContent";
import PageBody from "../../boxes/PageBody";
import LoadingScreen from "../../LoadingScreen";
import { useTranslation } from "react-i18next";
import useResponsive from '../hooks/useResponsive';

const alafiaLogo = "/img/care-balance/alafia-on-light-logo.svg";
const fundSuccessImg = "/img/care-balance/fund-wallet-success.png";

function FundCareBalanceSuccessContainer(props) {
  const { user, history } = props;

  const { t } = useTranslation("careBalance");

  const { isMobile } = useResponsive();

  if (_.isEmpty(user)) {
    return <LoadingScreen />;
  }

  return (
    <MainContent>
      <PageBody>
        <img
          src={alafiaLogo}
          alt="Alafia Logo"
          style={{
            width: isMobile ? "140px" : "200px",
          }}
        />

        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "32px",
            marginTop: "32px",
            flexDirection: isMobile ? "column-reverse" : "row",
          }}
        >
          <div
            style={{
              flex: 1,
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-start",
              gap: "16px",
            }}
          >
            <h1
              style={{
                fontWeight: 700,
                fontSize: isMobile ? "2.5rem" : "4rem",
                lineHeight: "100%",
                letterSpacing: "-4%",
                color: "#000000",
              }}
            >
              <span
                style={{
                  color: "#5097D1",
                }}
              >
                {t("fundSuccessTitle1")}
              </span>{" "}
              {t("fundSuccessTitle2")}
            </h1>
            <p
              style={{
                fontWeight: 500,
                fontSize: isMobile ? "1.5rem" : "2rem",
                lineHeight: isMobile ? "100%" : "3rem",
                letterSpacing: "0%",
                color: "#45474A",
              }}
            >
              {t("fundSuccessSubtitle")}
            </p>

            <button
              style={{
                borderRadius: "128px",
                paddingBlock: "16px",
                paddingInline: "24px",
                backgroundColor: "#094063",
                color: "#ffffff",
                fontSize: "1.5rem",
                fontWeight: 600,
                lineHeight: "22px",
                letterSpacing: "0%",
              }}
              onClick={() => {
                history.push("/");
              }}
              data-testid="fund-success-button"
            >
              {t("fundSuccessButtonLabel")}
            </button>
          </div>

          <div
            style={{
              flex: 1,
            }}
          >
            <img
              src={fundSuccessImg}
              alt="Fund success image"
              style={{
                maxHeight: "616px",
                height: "100%",
                width: "auto",
              }}
            />
          </div>
        </div>
      </PageBody>
    </MainContent>
  );
}

export default withRouter(FundCareBalanceSuccessContainer);
